import React, { useEffect, useState } from "react";
import { regions, fetchDevices } from "../services/api";
import "../styles/DataTable.css";

function DataTable({ onDeviceSelect, selectedDeviceId,  }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const loadDevices = async () => {
    try {
      setLoading(true);
      const devices = await fetchDevices();
      setData(devices);
      setError(null);
    } catch (err) {
      setError("Failed to load devices");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDevices();
  }, []);
  
  useEffect(() => {
    const handleToastClosed = () => {
      loadDevices();
    };

    window.addEventListener('toastClosed', handleToastClosed);

    return () => {
      window.removeEventListener('toastClosed', handleToastClosed);
    };
  }, []);

  const handleRowClick = (deviceId) => {
    onDeviceSelect(deviceId);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th style={{ width: "50px" }}></th>
            <th style={{ width: "40%" }}>Device Name</th>
            <th style={{ width: "40%" }}>Current Region</th>
            {/* <th style={{ width: "100px" }}></th> */}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr
              key={row.id}
              onClick={() => handleRowClick(row.id)}
              className={selectedDeviceId === row.id ? "selected" : ""}
            >
              <td onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  checked={selectedDeviceId === row.id}
                  onChange={() => handleRowClick(row.id)}
                />
              </td>
              <td>{row.deviceName}</td>
              <td>
                {regions.find((r) => r.countryCode === row.currentRegion)
                  ?.name || row.currentRegion}
              </td>
              {/* <td>
                <button className="action-button">Edit</button>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
